import { render, staticRenderFns } from "./ModuleList.vue?vue&type=template&id=49feb488"
import script from "./ModuleList.vue?vue&type=script&lang=js"
export * from "./ModuleList.vue?vue&type=script&lang=js"
import style0 from "./ModuleList.vue?vue&type=style&index=0&id=49feb488&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports